import { Component, ErrorInfo, ReactNode } from "react";
import ErrorPage from "pages/Error";

interface ErrorBoundaryProps {
  children: ReactNode;
}

interface ErrorBoundaryState {
  hasError: boolean;
  error: Error | null;
}

class ErrorBoundary extends Component<ErrorBoundaryProps, ErrorBoundaryState> {
  constructor(props: ErrorBoundaryProps) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error: Error): ErrorBoundaryState {
    return { hasError: true, error };
  }

  componentDidCatch(error: Error, errorInfo: ErrorInfo): void {
    console.error("[ErrorBoundary] Erreur non gérée :", error, errorInfo.componentStack);
  }

  render() {
    if (this.state.hasError) {
      return (
        <ErrorPage
          message={`Une erreur inattendue s'est produite : ${this.state.error?.message || "Erreur inconnue"}`}
        />
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
